import { render, staticRenderFns } from "./SecondAside.vue?vue&type=template&id=4f5b1123&scoped=true"
import script from "./SecondAside.vue?vue&type=script&lang=js"
export * from "./SecondAside.vue?vue&type=script&lang=js"
import style0 from "./SecondAside.vue?vue&type=style&index=0&id=4f5b1123&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5b1123",
  null
  
)

export default component.exports